import { useLayoutEffect, useRef } from 'react'

import { SupportRequestAttachment } from '@/app/entities/SupportRequest'
import { ChatItem } from '@/app/utils/supportChat'

import { ChatDateSeparator } from './ChatDateSeparator'
import { ChatMessageBubble } from './ChatMessageBubble'
import { ChatSystemEvent } from './ChatSystemEvent'

interface SupportRequestChatProps {
  items: ChatItem[]
  onOpenAttachment: (attachment: SupportRequestAttachment) => void
}

// Área de mensagens com rolagem própria; sempre ancorada na última mensagem.
export const SupportRequestChat = ({
  items,
  onOpenAttachment,
}: SupportRequestChatProps) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const container = containerRef.current
    if (container) container.scrollTop = container.scrollHeight
  }, [items.length])

  return (
    <div
      ref={containerRef}
      className="min-h-0 flex-1 overflow-y-auto px-3 py-2"
      aria-live="polite"
    >
      {!items.length && (
        <p className="py-6 text-center text-xs text-black04">
          Nenhuma mensagem ainda.
        </p>
      )}

      {items.map((item) => {
        if (item.kind === 'date') {
          return <ChatDateSeparator key={item.key} label={item.label} />
        }

        if (item.kind === 'event') {
          return (
            <ChatSystemEvent key={item.key} text={item.text} date={item.date} />
          )
        }

        return (
          <ChatMessageBubble
            key={item.key}
            isOwn={item.isOwn}
            authorLabel={item.authorLabel}
            showAuthor={item.showAuthor}
            text={item.text}
            date={item.date}
            attachments={item.attachments}
            onOpenAttachment={onOpenAttachment}
          />
        )
      })}
    </div>
  )
}
